import React from "react";

const StoryItem = ({ image, title, no, onClick }) => {
  return (
    <div
      className="max-w-[600px] flex items-center justify-between h-[90px] mx-auto mb-[20px] px-[23px] md:px-[32px] rounded-[10px] overflow-hidden cursor-pointer"
      onClick={onClick}
    >
      <div className="w-[90px] h-[90px] md:w-[120px] rounded-[10px] overflow-hidden">
        <img
          src={image}
          alt={title + "image"}
          className="w-[90px] h-[90px] md:w-[120px] object-cover"
          loading="lazy"
        />
      </div>
      <div className="flex-1 flex justify-start items-start h-[75px] text-base pl-[10px] text-left">
        {title}
      </div>
    </div>
  );
};

export default StoryItem;
